import React, { useEffect, useState } from "react";
import { Button, DetailCard, FormFieldSet, LogoLoader, Modal, showToast } from "../../../../../components";
import { addNote, deleteNote, getNotes } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
import { dateFormator } from "../../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { convertFromUTC } from "../../../../../utils/dateUtils";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { updateApplicantNotes } from "../../../../../redux/slices/recruitmentSourcing/SourcingSlice";
import { updateAllSourceNotes } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { updateAllOtherSourceNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";

const Notes = ({companyId}) => {
  const dispatch=useDispatch();
  const { user } = useSelector((state) => state?.auth);
  const [addNewModal,setAddNewModal]=useState(false)
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [loading, setLoading] = useState(false);
  const fetchNotes = async () => {
    try {
      setLoading(true);
      const res = await getNotes({
        coll: "Note",
        filters: { companyId: { type: "NONE", value: companyId } },
        lim: 10,
        pg: 1,
        extret: "uiid firstName",
        ret: "uiid note addedBy addedOn",
        sort: { addedOn: -1 },
      });

      if (res?.data?.data) {
        setNotes(res.data.data);
        res.data.data.forEach((note) => {
        const payload = {
          applicantId,
          uiid: note.uiid,
          newNoteUiid: note.uiid,
          note: note.note,
          addedBy: note.addedBy,
          addedOn: note.addedOn,
        };
        dispatch(updateApplicantNotes(payload));        // sourcing
        dispatch(updateAllSourceNotes(payload));        // internalDbES
        dispatch(updateAllOtherSourceNotes(payload));   // bdmJobs
      });
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      showToast("Failed to load notes", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleAddNote = async () => {
    if (!newNote.trim()) {
      showToast("Please enter a note", "error");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid, 
          companyId,
          note: newNote.trim(),
          source: 4, // for companies
        },
      };

      const res = await addNote(payload);

      if (res?.data) {
        showToast("Note added successfully", "success");
        setAddNewModal(false);
        setNewNote("");
        fetchNotes();
      } else {
        showToast("Failed to add note", "error");
      }
    } catch (error) {
      console.error("Error adding note:", error);
      showToast("Error while adding note", "error");
    } finally {
      setLoading(false);
    }
  };
  
  const handleDelete = async (noteUiid) => {
    try {
      setLoading(true);
      const res = await deleteNote({
        coll: "Note",
        uiid: noteUiid,
      });

      if (res?.data) {
        showToast("Note deleted successfully", "success");
        fetchNotes();
      } else {
        showToast("Failed to delete note", "error");
      }
    } catch (error) {
      console.error("Error deleting note:", error);
      showToast("Error deleting note", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) fetchNotes();
  }, [companyId]);

 if (loading) {
      return (
        <div className="flex items-center justify-center h-64">
          <LogoLoader />
        </div>
      );
    }
  // return (
  //   <div className="inner-section p-3 my-2 rounded flex flex-1 flex-col">
  //     <div className="flex justify-between items-center my-3">
  //       <h6 className=" font-semibold">Notes</h6>
  //       <Button icon={"add"} title={"Add Note"} size="sm" onClick={()=>setAddNewModal(true)}/>
  //     </div>
  //     <div className="flex flex-col gap-3 mb-4">
  //       <DetailCard
  //         size="xs"
  //         title={
  //           <div className="flex items-center gap-2">
  //             <Button
  //               type="icon"
  //               variant="text"
  //               icon={"business_center"}
  //               size="lg"
  //             />
  //             <div className="flex flex-col">
  //               <h6 className="font-bold">Astha</h6>
  //               <p className="text-primary-500 !text-[10px]">
  //                 created on Aug 25, 2025
  //               </p>
  //             </div>
  //           </div>
  //         }
  //         headeRight={
  //           <div className="flex items-center">
  //             <Button
  //               icon={"delete"}
  //               variant="text"
  //               type="icon"
  //               size="sm"
  //               color="black"
  //             />
  //             {/* <Button
  //               icon={"save"}
  //               variant="text"
  //               type="icon"
  //               size="sm"
  //               color="black"
  //             /> */}
  //           </div>
  //         }
  //       >
  //         <div className="my-2 mx-1 text-sm">
  //           Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque,
  //           repellendus?
  //         </div>
  //       </DetailCard>
  //       <DetailCard
  //         size="xs"
  //         title={
  //           <div className="flex items-center gap-2">
  //             <Button
  //               type="icon"
  //               variant="text"
  //               icon={"business_center"}
  //               size="lg"
  //             />
  //             <div className="flex flex-col">
  //               <h6 className="font-bold">Astha</h6>
  //               <p className="text-primary-500 !text-[10px]">
  //                 created on Aug 25, 2025
  //               </p>
  //             </div>
  //           </div>
  //         }
  //         headeRight={
  //           <div className="flex items-center">
  //             <Button
  //               icon={"delete"}
  //               variant="text"
  //               type="icon"
  //               size="sm"
  //               color="black"
  //             />
  //             {/* <Button
  //               icon={"save"}
  //               variant="text"
  //               type="icon"
  //               size="sm"
  //               color="black"
  //             /> */}
  //           </div>
  //         }
  //       >
  //         <div className="my-2 mx-1 text-sm">
  //           Lorem ipsum, dolor sit amet consectetur adipisicing elit.
  //           Consectetur modi incidunt eaque, eveniet ea aspernatur ipsa
  //           dignissimos, accusamus deserunt aperiam dolores harum sed ipsam
  //           totam! Placeat, nam neque cumque modi expedita sunt incidunt vitae
  //           quas nisi fugiat non cum delectus!
  //         </div>
  //       </DetailCard>
  //     </div>
  //     <Modal
  //       isOpen={addNewModal}
  //       onClose={() => setAddNewModal(false)}
  //       title={"Add Note"}
  //       width="max-w-3xl"
  //     >
  //       <div className="grid grid-cols-2 my-4">
  //         <FormFieldSet 
  //         type="text"
  //         placeholder="Enter Title"
  //         />
  //       </div>
  //       <FormFieldSet
  //         type="textArea"
  //         noTitle
  //         placeholder="Your Note"
  //         rows={3}
  //       />
  //       <div className="flex justify-end items-center gap-2 my-4">
  //         <Button title={"Cancel"} variant="outlined" size="sm" onClick={()=>setAddNewModal(false)}/>
  //         <Button title={"save"} size="sm" />
  //       </div>
  //     </Modal>
  //   </div>
  // );
  return (
    <div className="inner-section p-3 my-2 rounded flex flex-1 flex-col">
      <div className="flex justify-between items-center my-3">
        <h6 className="font-semibold">Notes</h6>
        <Button icon={"add"} title={"Add Note"} size="sm" onClick={() => setAddNewModal(true)} />
      </div>

      <div className="flex flex-col gap-3 mb-4">
        {notes.length > 0 ? (
          notes.map((note) => (
            <DetailCard
              key={note._id}
              size="xs"
              title={
                <div className="flex items-center gap-2">
                  <Button
                    type="icon"
                    variant="text"
                    icon={"business_center"}
                    size="lg"
                  />
                  <div className="flex flex-col">
                    <h6 className="font-bold">{formatWords2(note?.addedBy?.firstName || "-")}</h6>
                    <p className="text-primary-500 !text-[10px]">
                      Created on {dateFormator(convertFromUTC(note?.addedOn), "date-month-year")}
                    </p>
                  </div>
                </div>
              }
              headeRight={
                <div className="flex items-center">
                  <Button
                    icon={"delete"}
                    variant="text"
                    type="icon"
                    size="sm"
                    color="black"
                    // onClick={() => console.log("Delete note:", note.uiid)}
                    onClick={() =>{
                       handleDelete(note?.uiid)
                    }}
                  />
                </div>
              }
            >
              <div className="my-2 mx-1 text-sm">{note?.note}</div>
            </DetailCard>
          ))
        ) : (
          <p className="text-gray-500 text-sm">No notes found for this company.</p>
        )}
      </div>

      <Modal
        isOpen={addNewModal}
        onClose={() => setAddNewModal(false)}
        title={"Add Note"}
        width="max-w-3xl"
      >
        {/* <div className="grid grid-cols-2 my-4">
          <FormFieldSet 
          type="text" 
          placeholder="Enter Title" />
        </div> */}
        <FormFieldSet 
        type="textArea" 
        noTitle 
        placeholder="Your Note" 
        rows={4} 
        value={newNote}
        onChange={(val) => setNewNote(val)}
        />
        <div className="flex justify-end items-center gap-2 my-4">
          <Button title={"Cancel"} variant="outlined" size="sm" onClick={() => setAddNewModal(false)} />
          <Button title={"Save"} size="sm" onClick={handleAddNote}/>
        </div>
      </Modal>
    </div>
  );
};

export default Notes;
